import React, { Component } from 'react';
import {Route,Switch} from 'react-router-dom';


import Home from './../Home/Home';
import UserInfo from './../UserInfo/UserInfo'   //������Ϣ����
import CompanyList from './../Business/CompanyCenter/index';

import CompromiseListWait from './../Business/Compromise/index';          //��ҵ���ͽ�
import CompormiseListAlready from './../Business/CompormiseListAlready/index';          //��ҵ�Ѻͽ�
import CompromiseListOrder from './../Business/Compromise/index';
import CompanyRegistration from './../Business/CompanyAccord/index';          //���кͽ�
import RepaymentCenter from './../Business/CompanyRepayment/index';          //���кͽ�
import NotFound from '../../Err/Err';


class App extends Component {

    render() {
        return (
            <Switch>
                <Route exact path="/Content/Home" component={Home} />
                <Route exact path="/Content/UserInfo" component={UserInfo} />   {/*������Ϣ����*/}
                <Route path="/Content/Business/CompanyList" component={CompanyList} />
                <Route path="/Content/Business/CompromiseListWait" component={CompromiseListWait} />{/*��ҵ���ͽ�*/}
                <Route path="/Content/Business/CompormiseListAlready" component={CompormiseListAlready} />{/*��ҵ�Ѻͽ�*/}
                <Route path="/Content/Business/CompromiseListOrder/proces" component={CompromiseListOrder} />{/*��ҵ�Ѻͽ�*/}
                <Route path="/Content/Business/CompanyRegistration" component={CompanyRegistration} />{/*��ҵ�Ǽ�*/}
                <Route path="/Content/Business/RepaymentCenter" component={RepaymentCenter} />{/*��ҵ�Ǽ�*/}
                <Route path="/err" component={NotFound} />{/*��ҵ�Ѻͽ�*/}
                <Route component={NotFound} />
            </Switch>
        );
    }
}

export default App


// WEBPACK FOOTER //
// ./src/components/Content/Wrap/Router.js